export default __webpack_public_path__ + "static/game-left-515bbe173f76f43982f336956af6861c.svg";